import { Component, Input } from '@angular/core';

export enum ERROR_MESSAGE_POSITIONS {
  BOTTOM,
  TOP,
}

@Component({
  selector: 'nns-input',
  template: `
  <label class="nns-input-label" *ngIf="label">{{label}}</label>
  <div class="nns-input-error-text nns-input-error-position-top nns-animated"
       *ngIf="error && !errorPosition || errorPosition == errorMessagePositions.TOP"
  >{{error}}</div>
  <ng-content></ng-content>
  <div class="nns-input-info-text">{{info}}</div>
  <div class="nns-input-error-text nns-animated"
       *ngIf="error && !errorPosition || errorPosition == errorMessagePositions.BOTTOM"
  >{{error}}</div>
  `,
  styles: [`
    :host {
      padding:0 0 6px 0;
      display:block;
    }
    label {
      display:block;
      padding:0 0 6px 0;}
    :host /deep/ input {
      display:block;
      width:100%;
      padding:0 12px;
      height:44px;
      border:1px solid #cfd1d3;
      border-radius:2px;
      box-sizing:border-box;
      appearance:none;
    }
    :host /deep/ input:hover {border-color:#bbb;}
    :host /deep/ input:focus {border-bottom-color:#19a1b9;}
    .nns-input-info-text {padding:6px 0 0 0; font-size:12px;}
    .nns-input-error-text {
      padding:6px 0 0 0;
      font-size:12px;
      color:rgb(244, 67, 54);
    }
    .nns-input-error-position-top { margin-bottom: 10px;}

    :host.nns-invalid label {color:rgb(244, 67, 54);}
    :host.nns-invalid /deep/ input {border-bottom-color:rgb(244, 67, 54);}

    :host.small /deep/ input {height:28px;}

    :host /deep/ input[readonly] {background: #EBEFF1;}

  `, `
    :host-context(.nns-theme-night) /deep/ input {
      background: #3C4849;
      border-color:#2F3737;
      color:#fff;
    }
    :host-context(.nns-theme-night) /deep/ input:hover,
    :host-context(.nns-theme-night) /deep/ input:focus {
      border-color:#2F3737;
      background:rgba(181,181,181,0.10);
    }
    :host-context(.nns-theme-night) /deep/ input[readonly] {
      background:rgba(0,0,0,0.12);
    }
  `]
})
export class InputComponent {
  errorMessagePositions = ERROR_MESSAGE_POSITIONS;

  @Input() label;
  @Input() info;
  @Input() error;
  @Input() errorPosition;
}
